import React from "react";
import { FaPrint } from "react-icons/fa";

const Print = ({ printRef, label = "Print", title }) => {
  const handlePrint = () => {
    if (!printRef?.current) return;

    const content = printRef.current.innerHTML;

    const win = window.open("", "", "width=1000,height=700");

    win.document.write(`
    <html>
      <head>
        

        <!-- Bootstrap -->
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        />

        <style>
          body {
            
            position: relative;
            font-family: Arial, sans-serif;
          }

          h4 {
            font-weight: bold;
            font-size: 18px;
            margin-bottom: 10px;
          }

          /* WATERMARK */
          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-30deg);
            opacity: 0.1;
            z-index: 0;
            text-align: center;
            pointer-events: none;
          }

          .watermark-text {
            font-size: 80px;
            font-weight: bold;
            color: black;
          }

          /* CONTENT ABOVE WATERMARK */
          .print-content {
            position: relative;
            z-index: 2;
          }

          table {
            width: 100% !important;
            border-collapse: collapse !important;
          }

          th, td {
            border: 1px solid black !important;
            padding: 6px !important;
            font-size: 12px;
          }

          .table-responsive {
            overflow: visible !important;
          }

          /* FOOTER */
          .custom-footer {
            position: fixed;
            bottom: 10px;
            left: 10px;
            font-size: 12px;
          }

          @media print {
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
@page {
    margin: 5mm;
  }
            .sticky-top {
              position: static !important;
            }

            tr {
              page-break-inside: avoid;
            }
          }
        </style>
      </head>

      <body>

        <!-- TITLE -->
        <div class="row d-flex justify-content-center">
          <h4><u>${title || ""}</u></h4>
        </div>

        <!-- WATERMARK -->
        <div class="watermark">
          <div class="watermark-text">Rail-setu</div>
        </div>

        <!-- CONTENT -->
        <div class="print-content">
          ${content}
        </div>

        <!-- FOOTER -->
        <div class="custom-footer">
          railsetu.in
        </div>

      </body>
    </html>
    `);

    win.document.close();

    // IMPORTANT: Wait for Bootstrap CSS to load
    setTimeout(() => {
      win.focus();
      win.print();
      win.close();
    }, 500);
  };

  return (
    <button className="btn btn-outline-primary btn-sm" onClick={handlePrint}>
      <FaPrint /> {label}
    </button>
  );
};

export default Print;
